import { useTranslation } from 'react-i18next';
import { LayoutGrid } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/ui/empty-state';
import { getDashboardUrl } from '@/components/theme-provider';

/**
 * What `/` renders when the session has neither a board nor an inbox to land on: no brand in
 * scope takes orders, and none sells over WhatsApp. Without it the home route would forward to
 * the inbox and the inbox straight back — a redirect loop instead of a page. Reachable in
 * aggregate when the filter is narrowed to web-only brands without ORDERS; in a line session
 * only for a tenant with every channel off.
 */
export function NoSurfaceEmptyState() {
  const { t } = useTranslation();
  const dashboardUrl = getDashboardUrl();

  return (
    <EmptyState
      className="flex-1"
      icon={LayoutGrid}
      title={t('noSurface.title')}
      description={t('noSurface.description')}
      action={
        dashboardUrl && (
          <Button variant="outline" asChild>
            <a href={dashboardUrl}>{t('noSurface.action')}</a>
          </Button>
        )
      }
    />
  );
}
